import { odds } from '@/lib/format'

/** Lab fancy ticker — runs line as an integer when whole, else trimmed decimal. */
export function formatFancyRuns(runs: number): string {
  if (!Number.isFinite(runs)) return ''
  return Number.isInteger(runs) ? String(runs) : String(runs)
}

/**
 * Line Session workstation market (Overs/Runs/Ball Line) — not custom fancy.
 * Do not use `isLineSessionMarket({ marketType: 'fancy' })`; that includes fancy.
 */
export function isLineSessionBetListMarket(marketName: string | null | undefined): boolean {
  const name = String(marketName || '')
    .trim()
    .toLowerCase()
  return (
    name.includes('line session') ||
    name.includes('runs line') ||
    name.includes('overs line') ||
    name.includes('ball line') ||
    /\bline$/.test(name)
  )
}

/**
 * Lab bet-breakdown `fancyOdds(betRate)` for lineLadder: print betRate as-is (2).
 * Custom fancy / match keep previous runs-or-decimal behaviour.
 */
export function workstationOddsPlaced(input: {
  marketName: string
  betRate: number
  runs: number | null
}): string {
  if (isLineSessionBetListMarket(input.marketName)) {
    return formatFancyRuns(input.betRate)
  }
  if (input.runs != null) return formatFancyRuns(input.runs)
  return odds(input.betRate)
}

/** Lab Odds Matched for lineLadder: stored runs (41.5), not 2. */
export function workstationOddsMatched(input: {
  marketName: string
  runs: number | null
  averagePriceMatched: number
}): string {
  if (isLineSessionBetListMarket(input.marketName) && input.runs != null) {
    return formatFancyRuns(input.runs)
  }
  if (input.runs != null) return formatFancyRuns(input.runs)
  return odds(input.averagePriceMatched)
}
